import { BaseScreen } from "src/apps/components/baseScreen/BaseScreen";
import { Header } from "src/apps/components/header/Header";
import { LoginForm } from "./components/LoginForm";

import { CenteredContainer } from "./components/CenteredContainer";
import { colors } from "@permisso/permisso-components";

export const LoginScreen = () => {
  return (
    <BaseScreen
      backgroundColor={colors.grey0}
      header={<Header />}
      screenPadding="32px"
      mobileScreenPadding="20px"
    >
      <CenteredContainer>
        <LoginForm />
      </CenteredContainer>
    </BaseScreen>
  );
};
